module.exports = __webpack_public_path__ + "static/mummy_lord-8a9561ac213e2345260d6355eda922c4.jpeg";